import {
  HackathonData,
  useHackathonLeaderboardQuery
} from 'features/Leaderboard'
import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'

const HackathonLeaderboard = dynamic(
  () => import('../components/HackathonLeaderboard')
)

const HackathonDetail = dynamic(() => import('../components/HackathonDetail'))

const HackathonList = dynamic(() => import('../components/HackathonList'))

const HackathonLeaderboardPage = () => {
  const { data: sortedHackathonsData, isLoading } =
    useHackathonLeaderboardQuery()

  const [selectedHackathon, setSelectedHackathon] = useState<HackathonData>()

  useEffect(() => {
    if (!isLoading && sortedHackathonsData && sortedHackathonsData.length > 0) {
      setSelectedHackathon(sortedHackathonsData[0])
    }
  }, [sortedHackathonsData, isLoading])

  if (!sortedHackathonsData && !selectedHackathon && isLoading) {
    return (
      <div className="flex justify-center items-center mt-6">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-zinc-100" />
      </div>
    )
  }

  return (
    <div className="w-full max-w-7xl my-8 px-4 mx-auto flex flex-col md:flex-row md:space-x-8 flex-1">
      <h1 className="sr-only"> Hackathon Leaderboard</h1>
      <div className="mt-3 flex-1 flex flex-col bg-zinc-800 rounded-lg overflow-hidden">
        <HackathonList
          hackathonsData={sortedHackathonsData}
          onChange={(val) => setSelectedHackathon(val)}
          activeHackathonId={selectedHackathon?.id}
        />
      </div>

      <div className="mt-3 bg-zinc-900 flex-1 md:flex-none md:w-1/2">
        <HackathonDetail selectedHackathon={selectedHackathon} />
      </div>

      {selectedHackathon && (
        <div className="mt-3 bg-zinc-900 border-1 border-zinc-600 rounded-lg flex-1">
          <HackathonLeaderboard
            leaderboard={selectedHackathon.leaderboard}
            hackathonTitle={selectedHackathon?.title}
          />
        </div>
      )}
    </div>
  )
}

HackathonLeaderboardPage.auth = {
  shouldBeLoggedIn: true
}

HackathonLeaderboardPage.layout = {
  navProps: {
    type: 'product'
  }
}

HackathonLeaderboardPage.layout = {
  title: 'Hackathon | Devsnest'
}

export default HackathonLeaderboardPage
